import Progress from '@/components/controls/Progress'

export function progressPlugin(Vue) {
    const ProgressComponent = Vue.extend(Progress)

    Vue.prototype.$progress = function(params = {},isShow=false) {
     const p=new ProgressComponent({
            parent: this.$root,
            propsData: {
                params,isShow
            }
        })
        p.$mount()
        document.body.appendChild(p.$el)
    }
}
